import { useState } from "react";
import { useRecordTrainingEvent } from "@/lib/api/training-simulator/training-simulator.ts";
import { PostHogEvents, useTrackEvent } from "@/lib/posthog-events.ts";
import { TrainingEscalationModal } from "./training-escalation-modal.tsx";
import { ChatHeader, IconButton } from "@somethings-ui/web";
import { MoreVertical, TriangleAlert } from "lucide-react";

interface TrainingEscalationFabProps {
  attemptId: string;
  threadId: string | undefined;
}

export function TrainingEscalationFab({
  attemptId,
  threadId,
}: TrainingEscalationFabProps) {
  const [open, setOpen] = useState(false);
  const { track } = useTrackEvent();
  const { mutate: recordEvent } = useRecordTrainingEvent(attemptId);

  const handleClick = () => {
    track(PostHogEvents.SIMULATOR_ESCALATE_CLICK, {
      attempt_id: attemptId,
      thread_id: threadId,
    });
    if (threadId) {
      recordEvent({ eventType: "simulated_escalation_clicked", threadId });
    }
    setOpen(true);
  };

  return (
    <>
      <ChatHeader.Actions>
        <ChatHeader.ActionsMenu>
          <ChatHeader.ActionsMenu.Trigger>
            <IconButton
              variant="tertiary"
              size="md"
              shape="circle"
              aria-label="Conversation actions"
              icon={<MoreVertical className="size-5" />}
            />
          </ChatHeader.ActionsMenu.Trigger>
          <ChatHeader.ActionsMenu.Content className="w-60">
            <ChatHeader.ActionsMenu.Item
              icon={<TriangleAlert className="size-4" />}
              onSelect={handleClick}
            >
              Escalate
            </ChatHeader.ActionsMenu.Item>
          </ChatHeader.ActionsMenu.Content>
        </ChatHeader.ActionsMenu>
      </ChatHeader.Actions>
      <TrainingEscalationModal
        open={open}
        onClose={() => {
          track(PostHogEvents.SIMULATOR_ESCALATE_MODAL_DISMISS, {
            attempt_id: attemptId,
          });
          setOpen(false);
        }}
      />
    </>
  );
}
